<template lang="pug">
  div
    filter-table(
      layout="text, date"
      :rowSelectedCount="rowsSelected"
      @inputSearchFilter="inputSearchFilter"
      @resetDateFilter="resetDateFilter"
      @paramsDateFilter="paramsDateFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'fremesa', order: 'descending'}"
        @selection-change="handleSelectionChange"
        )
        ods-table-column(type='selection' width='55')
        ods-table-column(prop='fecliqrap' label='Fecha Liquidación' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecliqrap | formatDateLocale }}
        ods-table-column(prop='numrappel' label='Código' sortable)
        ods-table-column(prop='desrappel' label='Descripción' sortable)
        ods-table-column(prop='impaborap' label='Importe del Rappel' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impaborap | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='impliqrap' label='Importe Base del cálculo' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impliqrap | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='desindsitrap' label='Estado' sortable class-name="cell-tag")
          template(slot-scope="scope")
            ods-tag(:type="getType(scope.row.indsitrap)") {{ scope.row.desindsitrap }}
        ods-table-column(prop='acciones' label='acciones' class-name="cell-actions")
          template(slot-scope="scope" v-if="scope.row.indsitrap !== 3")
            ods-actions-menu(
              customClass="card-menu"
              icon="overflow-menu"
              color="#888A91"
              size="18"
              popoverPosition="bottom-end")
              ul.menu
                li.menu__item
                  a(href="#" @click.prevent="goToDetailRecibo(scope.row)") Ver recibos

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'RappelTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    comercio: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: { tipoestrap: 'C', codestrap: this.comercio.codcom },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      rowsSelected: null
    }
  },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Consultas - Rappel
      await this.$store.dispatch('listRappel', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.desrappel.toLowerCase().includes(text.toLowerCase()) ||
          res.desindsitrap.toLowerCase().includes(text.toLowerCase())
      })
    },

    paramsDateFilter (val) {
      const params = {
        ...this.defaultParams,
        ...val
      }
      this.getData(params)
    },

    resetDateFilter () {
      this.getInitialData()
    },

    handleSelectionChange (val) {
      this.rowsSelected = val.length
    },

    goToDetailRecibo (val) {
      this.$router.push({
        name: 'RecibosTable',
        params: {
          codproceso: 2,
          numrefrem: val.numrefrem,
          clamon: val.clamon,
          comercio: this.comercio
        }
      })
    },

    getType (row) {
      switch (row) {
        case 1:
          return 'warning'
        case 3:
          return 'danger'
        default:
          return 'success'
      }
    }
  },

  mounted () {
    this.getInitialData()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}
</style>
